import { ca } from '@cian/analytics';

import { TThunkAction } from 'shared/types/redux';

import { getOfferData, getPageData, getUserData } from '../selectors';

export const trackClickToOffer =
  (offerId: number): TThunkAction =>
  async (_, getState) => {
    const state = getState();

    ca('eventSite', {
      name: 'oldevent',
      category: 'Card_CW',
      action: 'to_card',
      label: 'card_header',
      products: [getOfferData(state, offerId)],
      page: getPageData(state),
      user: getUserData(state),
    });
  };
